import { useMemo } from 'react';
import { getCustomLogger } from '@onramp/utils/logger';
import { fetchWithCommonHeaders } from '@onramp/utils/requests';
import { createGraphqlEnvironment, GraphqlProvider as DataLayerProvider } from '@cbhq/data-layer';

export function GraphqlProvider({ children }: { children: React.ReactNode }) {
  const graphqlEnv = useMemo(() => {
    return createGraphqlEnvironment({
      graphqlUrl: '/v2/graphql/query',
      networkFetch: fetchWithCommonHeaders,
      logger: getCustomLogger('GraphqlProvider'),
    });
  }, []);

  return <DataLayerProvider environment={graphqlEnv}>{children}</DataLayerProvider>;
}
